import { getCookie } from 'cookie-utils'

export const RU = 1;
export const EN = 5;
export const UZ = 13;
export const KK = 2;

export const languageMap = {
  [RU]: { name: "ru", id: RU },
  [EN]: { name: "en", id: EN },
  [UZ]: { name: "uz", id: UZ },
  [KK]: { name: "kk", id: KK }
};

export const getLanguageType = id => {
  const languageId = Number(getCookie('languageId')) || id
  
  switch (languageId) {
    case EN:
      return languageMap[EN];
    case UZ:
      return languageMap[UZ];
    case KK:
      return languageMap[KK];
    default:
      return languageMap[RU];
  }
};


// WEBPACK FOOTER //
// ./js/constants/Language.js